import axios from 'axios';

const environmentReplaceKey = '{environment}';

function mainUrl(environmentId = null) {
  let url = process.env.VUE_APP_API_URL;

  if (!url.includes(environmentReplaceKey)) {
    return url;
  }

  if (environmentId !== null) {
    return url.replace(environmentReplaceKey, environmentId);
  }

  throw new Error('Environment id missing from either, env file, data-attribute or url');
}

export const fetchTypes = (environmentId) => {
  return axios.get(mainUrl(environmentId) + '/types');
}

export const fetchMethods = (environmentId) => {
  return axios.get(mainUrl(environmentId) + '/methods');
}

export const fetchBrands = (environmentId) => {
  return axios.get(mainUrl(environmentId) + '/brands');
}

export const fetchCategories = (environmentId) => {
  return axios.get(mainUrl(environmentId) + '/categories');
}

export const fetchImages = (environmentId) => {
  return axios.get(mainUrl(environmentId) + '/images');
}

export const fetchEnvironment = (environmentId) => {
  return axios.get(mainUrl(environmentId).replace('/charging', '') + '/info');
}

export const fetchInfoPopups = (environmentId) => {
  return axios.get(mainUrl(environmentId).replace('/charging', '') + '/info-popups');
}

export const fetchSettings = (environmentId) => {
  return axios.get(mainUrl(environmentId) + '/settings');
}

export const searchCar = (environmentId, postData) => {
  return axios.post(mainUrl(environmentId) + '/cars/search', postData)
}

export const fetchBuild = (environmentId, buildNr) => {
  return axios.get(mainUrl(environmentId) + '/build/' + buildNr)
}

export const makeBuild = (environmentId, postData) => {
  return axios.post(mainUrl(environmentId) + '/build/make', postData);
}
